module.exports = "/_next/static/files/b1d633f0370bd1efbaf0f60bf19b88e1.png";